import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import _ from "lodash";
import { provide, useAttrs, computed } from "vue";
import { twMerge } from "tailwind-merge";
import { TabList as HeadlessTabList } from "@headlessui/vue";

export type ProvideList = {
  variant?: Variant;
};

interface ListProps extends ExtractProps<typeof HeadlessTabList> {
  variant?: Variant;
}
// eslint-disable-next-line

const __default__ = {
  inheritAttrs: false,
};

type Variant = "tabs" | "pills" | "boxed-tabs" | "link-tabs";

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'List',
  props: {
    variant: { default: "tabs" }
  },
  setup(__props: any) {

const { variant } = __props as { variant: Variant }



const attrs = useAttrs();
const computedClass = computed(() =>
  twMerge([
    variant == "tabs" && "border-b border-slate-200 dark:border-darkmode-400",
    "w-full flex",
    typeof attrs.class === "string" && attrs.class,
  ])
);

provide<ProvideList>("list", {
  variant: variant,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(HeadlessTabList), _mergeProps({
    as: "ul",
    class: _unref(computedClass)
  }, _unref(_).omit(_unref(attrs), 'class')), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})